import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="micro"
export default class extends Controller {
  static values = {
    progress: Number
  }

  connect() {
  }

  open() {
    if (this.progressValue === 0) {
      Turbo.visit('/voice/start');
    } else {
      document.querySelector('.popup').classList.add('show');
    }
  }

  close() {
    document.querySelector('.popup').classList.remove('show');
  }
}
